// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollDownAction(60, 'scroll');

		scrollW();

		window.addEventListener('scroll', function(){
			scrollW();
		})

		

		if(document.getElementById('secondary-nav')){
			const badge = document.createElement('span');
			for (let i = 1; i < 4; i++) {
				let divBadge = document.createElement('div');
				if(i == 1){
					badge.classList.add('icon');
					divBadge.insertAdjacentElement('beforeend', badge);
				}
				divBadge.classList.add('deco');
				divBadge.classList.add(`n-${i}`);
				divBadge.setAttribute('aria-hidden','true');
				document.getElementById('secondary-nav').insertAdjacentElement('beforeend', divBadge);
			}
		}

	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	if(document.querySelector('.quad-tabs')){
		let quadTabs = document.querySelectorAll('.quad-tabs');

		quadTabs.forEach((quad)=>{
			let tabs = quad.querySelectorAll('.quad-tabs__tabs ul li');
			let items = quad.querySelectorAll('.quad-tabs__item');
			let lastTab = null;

			tabs.forEach((tab)=>{
				tab.addEventListener('click', ()=>{
					let data = tab.dataset.tab;
					if(lastTab){
						lastTab.classList.remove('active');
					}
					items.forEach((item)=>{
						item.classList.toggle('hidden', item.dataset.tab != data);
					});
					tab.classList.add('active');
					lastTab = tab;
				})
			});

			tabs[0].click();
		});
	}

	if(document.querySelector('.location-map__point')){
		let pointsMap = document.querySelectorAll('.location-map__point');
		let pointsItem = document.querySelectorAll('.location-map__item');
		let lastPoint = null;
		
		pointsMap.forEach((point)=>{
			point.addEventListener('click', ()=>{
				let data = point.dataset.point;
				point.classList.add('active');
				if(lastPoint){
					lastPoint.classList.remove('active');
				}
				lastPoint = point;
				pointsItem.forEach((item)=>{
					item.classList.toggle('hidden', item.dataset.point != data);
				});
			})
		})

		pointsMap[0].click();
	}

	if(document.querySelector('.amenities-tabs')){
		let quadAmenities = document.querySelectorAll('.amenities-tabs');

		quadAmenities.forEach((quad)=>{
			let tabs = quad.querySelectorAll('.amenities-tabs__filter ul li');
			let items = quad.querySelectorAll('.amenities-tabs__item');
			let lastTab = null;

			tabs.forEach((tab)=>{
				tab.addEventListener('click', ()=>{
					let data = tab.dataset.tab;
					if(lastTab){
						lastTab.classList.remove('active');
					}
					items.forEach((item)=>{
						item.classList.toggle('hidden', item.dataset.tab != data);
					});
					tab.classList.add('active');
					lastTab = tab;
				})
			});

			tabs[0].click();
		});
	}

	if(document.querySelector('.form-module-wrapper')){
		let allForms = document.querySelectorAll('.form-module-wrapper');

		allForms.forEach((forms)=>{
			forms.querySelector('.form-module').classList.add('animate-fade', 'top');
		})
	}

	if(document.querySelector('.text-modules-wrapper')){
		let allTexts = document.querySelectorAll('.text-modules-wrapper');

		allTexts.forEach((texts)=>{
			texts.querySelector('.text-modules').classList.add('animate-fade', 'top');
		})
	}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	if(document.querySelector('.js-close-menu')){
		let allClose = document.querySelectorAll('.js-close-menu');

		allClose.forEach((close)=>{
			close.addEventListener('click', ()=>{
				document.getElementById('menu-responsive').classList.remove('show');
			})
		})
	}

	if(document.querySelector('.js-open-menu-responsive')){
		let allOpens = document.querySelectorAll('.js-open-menu-responsive');

		allOpens.forEach((open)=>{
			open.addEventListener('click', ()=>{
				document.getElementById('menu-responsive').classList.add('show');
			})
		})
	}

	if(document.querySelector('.js-open-booking')){
		let btnBooking = document.querySelectorAll('.js-open-booking');

		btnBooking.forEach((btn)=>{
			btn.addEventListener('click', ()=>{
				document.getElementById('booking-widget-brand') ? document.querySelector('#container-booking-widget-brand').classList.toggle('show') :document.querySelector('#container-booking-widget').classList.toggle('show');
			})
		})
	}

	if(document.querySelector('.rooms-overview')){
		let overviewRooms = document.querySelectorAll('.rooms-overview__list ul li');
		let imagesRooms = document.querySelectorAll('.rooms-overview__image');
		let lastRoom = overviewRooms[0];

		overviewRooms.forEach((room)=>{
			room.addEventListener('mouseenter',()=>{
				let dataRoom = room.dataset.room;
				if(lastRoom){
					lastRoom.classList.remove('active');
				}
				imagesRooms.forEach((item)=>{
					item.classList.remove('active');
					if(item.dataset.room == dataRoom){
						item.classList.add('active');
					}
				});
				room.classList.add('active');
				lastRoom = room;
			})
		});
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
		if(document.getElementById('container-booking-widget-brand') && document.getElementById('home')  && window.innerWidth > 600){
			document.getElementById('container-booking-widget-brand').classList.add('hide');
		}
		if(document.getElementById('container-booking-widget')){
			document.getElementById('container-booking-widget').classList.add('hide');
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.getElementById('container-booking-widget-brand')  && document.getElementById('home') && window.innerWidth > 600){
			document.getElementById('container-booking-widget-brand').classList.remove('hide');
		}
		if(document.getElementById('container-booking-widget')){
			document.getElementById('container-booking-widget').classList.remove('hide');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
